import React from 'react';
import { connect } from 'react-redux';
import { openAssetsViewer, resetAssetViewer } from '@manakin/core/dist/actions';
import { compose } from 'recompose';
import BaseSelectImageField from './BaseSelectImageField';
import { withTranslation } from 'react-i18next';

class BynderSelectImageField extends React.Component {

	handleOpenAssetViewer = (uuid, fields) => {
		const { openAssets, readOnly = false, multi = false } = this.props;

		if (!readOnly) {
			if (fields?.assets) {
				openAssets(uuid, multi, fields.assets);
			} else {
				openAssets(uuid, multi);
			}
		}
	};

	handleChange = (uuid, imageData) => {
		const { form, name } = this.props;

		if (imageData[uuid]) {
			if (this.props.multi) {
				let arr = [];
				const obj = { ...imageData[uuid] };
				for (var key in obj) {
					if (obj[key].derivative && obj[key].derivative != 'none') arr.push({ asset: obj[key] });
				}
				form.onFieldChange({
					key: name,
					value: [...arr],
				});
			} else {
				form.onFieldChange({
					key: name,
					value: {
						bynderId: imageData[uuid].id,
						derivative: imageData[uuid].size,
						url: imageData[uuid].url,
					},
				});
			}
		}
	};

	handleDeleteImage = (event) => {
		const { t } = this.props;
		event.stopPropagation();

		if (window.confirm(t('core.select-image-field.confirm-delete'))) {
			const { form, name } = this.props;

			form.onFieldChange({
				key: name,
				value: {
					bynderId: null,
					derivative: null,
				},
			});
		}
	};

	render() {
		return <BaseSelectImageField
			{...this.props}
			handleImageClick={this.handleOpenAssetViewer}
			handleDeleteImage={this.handleDeleteImage}
			handleChange={this.handleChange}
		/>
	}
}

const mapStateToProps = (state) => ({
	imageData: state.imageData,
});

const mapDispatchToProps = (dispatch) => ({
	openAssets: (name, multi, assets = []) =>
		dispatch(openAssetsViewer(name, multi, assets)),
	resetAssets: () => dispatch(resetAssetViewer()),
});

export default compose(
	connect(mapStateToProps, mapDispatchToProps),
	withTranslation(),
)(BynderSelectImageField);
